"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function deez(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.2802 14.895C10.554 14.7173 12.3938 13.59 14.1863 12.492C15.4785 11.7015 15.4785 11.7015 15.456 11.6243C15.4335 11.5305 7.431 6.6675 7.34925 6.61875C7.19724 6.52898 7.04672 6.43672 6.89775 6.342C7.04475 6.24 7.3305 6.045 7.6725 5.8125L8.505 5.25L9.0765 5.592C9.7815 6.0135 17.5215 10.761 18.606 11.4368C18.1635 11.703 16.596 12.6308 14.4885 13.872L10.3012 16.3395C10.2936 16.1211 10.2886 15.9026 10.2863 15.684C10.2815 15.4213 10.2798 15.1585 10.281 14.8958L10.2802 14.895ZM8.50425 10.173C8.643 10.2555 8.883 10.4003 9.1785 10.584L9.95025 11.0625L9.96675 12.51C10.0155 16.6928 10.0155 16.6928 10.0763 16.7355L10.1168 16.7633L10.1617 16.7468C10.1842 16.74 10.1925 16.737 18.315 11.9453L18.75 11.6888L18.6068 13.701L18.5543 13.731C15.2099 15.6521 11.8626 17.5681 8.5125 19.479C8.5095 18.9548 8.505 17.1653 8.50425 14.832V10.173ZM6.75 18.6L6.76875 6.62475L7.05975 6.7965C7.29375 6.933 8.87175 7.89525 10.6545 8.98575C11.9311 9.76841 13.2096 10.5479 14.49 11.3243L15.0262 11.6468L13.2532 12.7313L12.8992 12.525C12.1892 12.0962 11.4817 11.6632 10.7768 11.226C10.0894 10.7997 9.39936 10.3777 8.70675 9.96L8.21775 9.675L8.214 14.7518C8.2125 17.0423 8.21025 18.9458 8.20875 19.5008C8.064 19.413 7.81725 19.2608 7.52775 19.0808L6.75 18.6Z", fill: color }));
}
exports["default"] = deez;
//# sourceMappingURL=deez.js.map